import {withHandlers} from 'recompose'

import compose from 'lodash/flowRight'
import type * as React from 'react'
import {connect} from 'react-redux'

import {isEventWithSpecialKeyPressed} from '../../../../../../utils/keys'
import {fetchBuildLogMessages} from '../../../BuildLog.actions'
import {
  getKeyForBuildLogData,
  INITIAL_NEXT_MESSAGES_COUNT,
  INITIAL_PREVIOUS_MESSAGES_COUNT,
} from '../../../BuildLog.utils'

import TimelinePoint from './TimelinePoint'
import type {ActionProps, ReduxInnerProps} from './TimelinePoint.types'

const actionCreators: ActionProps = {
  fetchMessages: fetchBuildLogMessages,
}
export default compose(
  connect(null, actionCreators),
  withHandlers({
    onClick:
      ({fetchMessages, buildId, buildAnchor, logTarget}: ReduxInnerProps) =>
      (event: React.MouseEvent<any>) => {
        event.stopPropagation()

        if (!isEventWithSpecialKeyPressed(event)) {
          event.preventDefault()
          fetchMessages({
            buildId,
            buildLogKey: getKeyForBuildLogData({
              type: 'full',
              target: logTarget,
            }),
            options: {
              count: [INITIAL_NEXT_MESSAGES_COUNT, INITIAL_PREVIOUS_MESSAGES_COUNT],
              logAnchor: buildAnchor,
              expandState: [buildAnchor],
            },
            invalidate: true,
            target: logTarget,
          })
        }
      },
  }),
)(TimelinePoint)
